import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import useCustomChakraTheme from "hooks/use-custom-chakra-theme";
import React from "react";

interface GetPhoneNumberProps {
  getPhoneNumber: () => void;
}

const GetPhoneNumber = ({ getPhoneNumber }: GetPhoneNumberProps) => {
  const { colorScheme } = useCustomChakraTheme();

  return (
    <>
      <Heading> Get your phone number!</Heading>

      <Box my={4} textAlign="center">
        <Text> This number is our gift to you for signing up to Fuzey.</Text>
        <Text> It will help you unlock Fuzey&apos;s powerful features.</Text>
      </Box>

      <Flex justifyContent="center">
        <Button
          colorScheme={colorScheme}
          my={4}
          size="md"
          onClick={getPhoneNumber}
        >
          {" "}
          Get your phone number now
        </Button>
      </Flex>
    </>
  );
};

export default GetPhoneNumber;
